import { useEffect, useState } from "react";
import api from "../lib/api";
import { Wheat, ChevronRight } from "lucide-react";
import { fmtDateIT, groupRationBySlot, DEFAULT_CATEGORY_ORDER } from "../lib/feedingConstants";
import { SlotBlocks } from "./ProfendaBlocks";

// Read-only "Profenda corrente" summary card for HorseDetail (single source, no duplication).
// Applies the categoria -> alimento -> quantità hierarchy and the shared sorting rule.
export default function FeedingRationCard({ stableId, horseId, onOpen }) {
  const [ration, setRation] = useState(undefined);
  const [items, setItems] = useState({});
  const [slots, setSlots] = useState([]);
  const [catOrder, setCatOrder] = useState(DEFAULT_CATEGORY_ORDER);

  useEffect(() => {
    let alive = true;
    Promise.all([
      api.get(`/stables/${stableId}/horses/${horseId}/feed-ration`),
      api.get(`/stables/${stableId}/feed-items`, { params: { include_archived: true } }),
      api.get(`/stables/${stableId}/feed-meal-slots`),
      api.get(`/stables/${stableId}/feed-category-order`),
    ]).then(([r, it, sl, co]) => {
      if (!alive) return;
      setRation(r.data || null);
      setItems(Object.fromEntries(it.data.map((i) => [i.id, i])));
      setSlots(sl.data.filter((s) => !s.archived));
      setCatOrder(co.data.order);
    }).catch(() => { if (alive) setRation(null); });
    return () => { alive = false; };
  }, [stableId, horseId]);

  if (!ration || !ration.lines?.length) return null;
  const groups = groupRationBySlot(ration.lines, slots, items, catOrder);

  return (
    <div className="bg-white rounded-xl border border-[#E5DEC9] p-4" data-testid="horse-profenda-card">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-mono-label text-[11px] text-[#8C532B] flex items-center gap-1.5"><Wheat className="h-4 w-4" /> Profenda corrente</h2>
        <button onClick={onOpen} data-testid="horse-profenda-open" className="flex items-center gap-1 text-xs text-[#8C532B] hover:text-[#1B3B2B]">Vedi Alimentazione <ChevronRight className="h-3.5 w-3.5" /></button>
      </div>
      <div className="space-y-2.5">
        {groups.map((g, i) => (
          <div key={i}>
            <p className="font-mono-label text-[10px] uppercase text-[#8C532B] mb-1">{g.slot.name}</p>
            <SlotBlocks slotLines={g.lines} itemsMap={items} catOrder={catOrder} variant="stacked" />
          </div>
        ))}
      </div>
      <p className="text-[11px] text-[#9AA39C] mt-3">Valida dal {fmtDateIT(ration.valid_from)}</p>
    </div>
  );
}
